import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/customers',
    name: 'POST_CUSTOMER',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
